export default "/images/c065946a6883738b6915079e1e2f35d3.png";